export type RetireFailure = {
  id: number
  name: string
  error: string
}

export type RetireProgress = {
  completed: number
  total: number
  failures: RetireFailure[]
}

export type RetireOutcome =
  | { kind: 'success' }
  | { kind: 'failure', id: number, name: string, error: string }

export const startRetireProgress = (total: number): RetireProgress => ({
  completed: 0,
  total,
  failures: []
})

export const applyRetireOutcome = (prev: RetireProgress, outcome: RetireOutcome): RetireProgress => {
  if (outcome.kind === 'success') {
    return { ...prev, completed: prev.completed + 1 }
  }
  return {
    ...prev,
    completed: prev.completed + 1,
    failures: [...prev.failures, { id: outcome.id, name: outcome.name, error: outcome.error }]
  }
}

export const isRetireInProgress = (progress: RetireProgress | null): boolean => {
  return progress !== null && progress.completed < progress.total
}

export const extractRetireErrorMessage = (err: any): string => {
  return err?.response?.data?.message ?? err?.message ?? 'Unknown error'
}

export const calculatePaginationTotal = (loadedPageCount: number, hasMore: boolean, pageSize: number): number => {
  return (loadedPageCount + (hasMore ? 1 : 0)) * pageSize
}

export type RetireAlertState = {
  type: 'info' | 'success' | 'error'
  message: string
}

export const deriveRetireAlertState = (progress: RetireProgress): RetireAlertState => {
  if (isRetireInProgress(progress)) {
    return { type: 'info', message: 'Retiring items…' }
  }
  if (progress.failures.length > 0) {
    return { type: 'error', message: 'Retire completed with errors' }
  }
  return { type: 'success', message: 'Retire complete' }
}
